import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faChevronDown, faChevronRight, faQuestionCircle, faClose } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { colorCode } from '../StudentSessionReport/components/constants';
import Modal from '../../../../../../components/Modal';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import { useGetQuestionAnswerResponseMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useSelector } from 'react-redux';
import { selectFerpaState } from '../../../../../../features/authentication/authSlice';

const IndividualQuestionTableVertical = ({
  details,
  sessionReportOptions,
  mainTotalTableData,
  showRetryOptions,
  includesRetakeData,
  retryScoringOptionId,
}) => {
  const [IndividualQuestionExpand, setIndividualQuestionExpand] = useState(true);
  const [answerModalOpen, setAnswerModalOpen] = useState(false);
  const [questionAnwserResponse, setQuestionAnwserResponse] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [getQuestionAnswerResponse] = useGetQuestionAnswerResponseMutation();
  const ferpaEnabled = useSelector(selectFerpaState);

  const answerModalHandler = async (result) => {
    if (result.status === 'Not Answered') return;
    setQuestionAnwserResponse(null);
    setAnswerModalOpen(!answerModalOpen);
    const options = {
      questionId: result.questionId,
      sessionId: details?.studentResults[0]?.sessionId,
      courseId: result.courseId
    };

    try {
      const response = await getQuestionAnswerResponse(options).unwrap();
      setQuestionAnwserResponse(response);
    } catch (error) {
      console.log(error);
    }
    setSelectedAnswer(result);
  };

  return (
    <>
      <div className="mt-5">
        <div className="d-flex justify-content-between">
          <p className="table_tittle">
            Individual Question Results
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="custom-tooltip">
                  Click the status indicator for specific student answers
                </Tooltip>
              }>
              <FontAwesomeIcon icon={faQuestionCircle} />
            </OverlayTrigger>
          </p>
          <button
            style={{
              background: '#e1eeff',
              color: 'rgba(84, 113, 200, 0.6)',
              width: '30px',
              height: '30px',
              textAlign: 'center',
              border: 'none',
              marginLeft: '10px'
            }}
            className="rounded-circle"
            onClick={() => setIndividualQuestionExpand(!IndividualQuestionExpand)}>
            {IndividualQuestionExpand ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </button>
        </div>
        {IndividualQuestionExpand && (
          <>
            <div className="d-flex gap-3">
              <p>
                <strong>Student Name: </strong>
                {!ferpaEnabled ? 'name hidden' : details?.studentResults[0]?.name}
              </p>{' '}
              &nbsp;
              <p>
                <strong>Student ID: </strong>
                {!ferpaEnabled
                  ? 'identification hidden'
                  : details?.studentResults[0]?.identification}
              </p>{' '}
              &nbsp;
              <p>
                <strong>Score: </strong>
                {typeof mainTotalTableData?.totals?.score === 'number'
                  ? Math.round(mainTotalTableData?.totals?.score)
                  : mainTotalTableData?.totals?.score}
              </p>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <table id="individualQuestion" className={'w-100'}>
                  <tr className="table-head">
                    <th className="text-center">Questions</th>
                    <th className="text-center">Answers</th>
                  </tr>
                  {details?.studentResults[0]?.results.map((result, index) => {
                    if (result.crStatus) {
                      if (
                        result.crStatus?.score == 127 &&
                        details?.studentResults[0]?.assignmentStarted &&
                        sessionReportOptions?.scoreUnscoredCRZero
                      ) {
                        return (
                          <tr className="table-body" key={index}>
                            <td
                              onClick={() =>
                                questionPreviewHandler(
                                  result.questionId
                                )
                              }
                              className="text-center cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="text-center">
                              {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                                result.status == 'Not Answered' ? null : (
                                <div
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => answerModalHandler(result)}
                                  className="indication mx-auto"
                                  title="Answered (0 points out of 1 maximum points">
                                  {'[0]'}
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      } else if (
                        details?.studentResults[0]?.assignmentCompleted == false &&
                        details?.studentResults[0]?.assignmentStarted &&
                        result.crStatus.status !== 'Answered' &&
                        sessionReportOptions?.scoreStartedNotCompletedIncorrect
                      ) {
                        return (
                          <tr className="table-body" key={index}>
                            <td
                              onClick={() =>
                                questionPreviewHandler(
                                  result.questionId,
                                  details?.courseId
                                )
                              }
                              className="text-center cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="text-center">
                              {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                                result.status == 'Not Answered' ? null : (
                                <div
                                  onClick={() => answerModalHandler(result)}
                                  style={{
                                    '--background': '#FFE3E3',
                                    '--iconColor': '#F84646',
                                    cursor: 'pointer'
                                  }}
                                  className="indication mx-auto">
                                  <FontAwesomeIcon icon={faClose} />
                                  <span className="visually-hidden">X</span>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      } else if (
                        result.crStatus?.status == 'Answered' &&
                        result.crStatus?.score == 127
                      ) {
                        return (
                          <tr className="table-body" key={index}>
                            <td
                              onClick={() =>
                                questionPreviewHandler(
                                  result.questionId,
                                  details?.courseId
                                )
                              }
                              className="text-center cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="text-center">
                              {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                                result.status == 'Not Answered' ? null : (
                                <div
                                  style={{
                                    '--background': '#9694FF',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => answerModalHandler(result)}
                                  className="indication mx-auto"
                                  title={`Answered (not scored yet,maximum points are ${result.crStatus.maxPoints})`}>
                                  {' '}
                                  <span className="visually-hidden">127</span>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      } else if (
                        result.crStatus?.status === 'Answered' &&
                        result.crStatus?.score !== 127
                      ) {
                        return (
                          <tr className="table-body" key={index}>
                            <td
                              onClick={() =>
                                questionPreviewHandler(
                                  result.questionId,
                                  details?.courseId
                                )
                              }
                              className="text-center cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="text-center">
                              {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                                result.status == 'Not Answered' ? null : (
                                <div
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => answerModalHandler(result)}
                                  className="indication mx-auto"
                                  title={`Answered (${result.crStatus?.score} points out of ${result.crStatus.maxPoints} maximum points)`}>
                                  {`[${result.crStatus?.score}]`}{' '}
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      } else if (result.crStatus.status == 'In Progress') {
                        return (
                          <tr className="table-body" key={index}>
                            <td
                              onClick={() =>
                                questionPreviewHandler(
                                  result.questionId,
                                  details?.courseId
                                )
                              }
                              className="text-center cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="text-center">
                              {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                                result.status == 'Not Answered' ? null : (
                                <div
                                  onClick={() => answerModalHandler(result)}
                                  style={{
                                    '--background': '#FC6EFF',
                                    cursor: 'pointer'
                                  }}
                                  className="indication mx-auto"
                                  title={'In Progress'}>
                                  {' '}
                                  <span className="visually-hidden">In Progress</span>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr className="table-body" key={index}>
                            <td
                              onClick={() =>
                                questionPreviewHandler(
                                  result.questionId,
                                  details?.courseId
                                )
                              }
                              className="text-center cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="text-center">
                              {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                                result.status == 'Not Answered' ? null : (
                                <div
                                  title="Not Answered"
                                  style={{
                                    '--background': '#FFFFFF',
                                    '--border': '1px solid #000000 ',
                                    cursor: 'pointer'
                                  }}
                                  className="indication mx-auto">
                                  {' '}
                                  <span className="visually-hidden">Not Answered</span>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      }
                    } else if (
                      sessionReportOptions?.scoreStartedNotCompletedIncorrect &&
                      result.status == 'Not Answered'
                    ) {
                      return (
                        <tr className="table-body" key={index}>
                          <td
                            onClick={() =>
                              questionPreviewHandler(
                                result.questionId,
                                details?.courseId
                              )
                            }
                            className="text-center cursor-pointer">
                            {index + 1}
                          </td>
                          <td
                            className="text-center"
                            style={{ backgroundColor: `${result.overridden ? 'yellow' : ''}` }}>
                            {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                              result.status == 'Not Answered' ? null : (
                              <div
                                onClick={() => answerModalHandler(result)}
                                className="indication mx-auto"
                                style={{
                                  '--background': '#FFE3E3',
                                  '--iconColor': '#F84646',
                                  cursor: 'pointer'
                                }}>
                                <FontAwesomeIcon icon={faClose} />
                                <span className="visually-hidden">X</span>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    } else {
                      const color = colorCode.find((code) => code?.status === result.status);

                      return (
                        <tr className="table-body" key={index}>
                          <td
                            onClick={() =>
                              questionPreviewHandler(
                                result.questionId,
                                details?.courseId
                              )
                            }
                            className="text-center cursor-pointer">
                            {index + 1}
                          </td>
                          <td
                            className="text-center"
                            style={{ backgroundColor: `${result.overridden ? 'yellow' : ''}` }}>
                            {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                              result.status == 'Not Answered' ? null : (
                              <div
                                onClick={() => answerModalHandler(result)}
                                className="indication mx-auto"
                                style={{
                                  '--background': color?.backgroundColor,
                                  '--iconColor': color?.iconColor,
                                  '--border': color?.border,
                                  cursor: 'pointer'
                                }}>
                                {color?.icon}
                                {color?.icons &&
                                  color?.icons.map((item, index) => (
                                    <>
                                      {item.icon2}
                                      {item.icon1}
                                    </>
                                  ))}
                                <span className="visually-hidden">{color.hiddenValue}</span>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    }
                  })}
                  <tr className="table-head">
                    <th className="text-center">Total Score</th>
                    <th className="text-center">
                      {typeof mainTotalTableData?.totals?.score === 'number'
                        ? Math.round(mainTotalTableData?.totals?.score)
                        : mainTotalTableData?.totals?.score}
                    </th>
                  </tr>
                </table>
              </div>
              <div className="col-lg-9 ml-3 individual-question-right">
                <div className="row mx-0 px-3">
                  {colorCode.map((item, index) => {


                    // Hide retries icon if requested
                    if (!showRetryOptions && item.id == 3) return;
                    if (!includesRetakeData && item.id == 8) return;

                    // If retries are shown adjust text according to scoring
                    if (item.id == 3) {
                      switch (retryScoringOptionId) {
                        case 1:
                          item.name = 'Correct on Retry (counted as no-credit in the scoring)';
                          break;
                        case 2:
                          item.name = 'Correct on Retry (counted as half-credit in the scoring)';
                          break;
                        case 3:
                          item.name = 'Correct on Retry (counted as full-credit in the scoring)';
                          break;
                      }
                    }

                    return (
                      <div key={index} className="col-lg-6">
                        <div className="d-flex gap-3">
                          <div
                            className="indication"
                            style={{
                              '--background': item.backgroundColor,
                              '--iconColor': item.iconColor,
                              '--border': item?.border
                            }}>
                            {item?.icon}
                            {item?.icons &&
                              item?.icons.map((item, index) => (
                                <>
                                  {item.icon2}
                                  {item.icon1}
                                </>
                              ))}
                          </div>
                          <p key={index}>{item?.name}</p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <Modal
        titleName={'Student Reponse to question'}
        isOpen={answerModalOpen}
        contentWidth={'65%'}
        onClose={() => setAnswerModalOpen(false)}>
        {questionAnwserResponse ? (
          <div>
            {selectedAnswer?.status === 'Correct' && (
              <>
                <table>
                  <tr>
                    <td>Status : </td>
                    <td>{questionAnwserResponse?.status}</td>
                  </tr>
                  <tr>
                    <td>Correct Answer : </td>
                    <td>{questionAnwserResponse?.correctAnswer}</td>
                  </tr>
                  <tr>
                    <td>Question Id : </td>
                    <td>{questionAnwserResponse?.questionId}</td>
                  </tr>
                </table>
              </>
            )}

            {(selectedAnswer?.status === 'Incorrect' ||
              selectedAnswer?.status === 'Correct on Retry') && (
                <>
                  <table>
                    <tr>
                      <td>Status : </td>
                      <td>{questionAnwserResponse?.status}</td>
                    </tr>
                    <tr>
                      <td>Correct Answer : </td>
                      <td>{questionAnwserResponse?.correctAnswer}</td>
                    </tr>
                    <tr>
                      <td>Question Id : </td>
                      <td>{questionAnwserResponse?.questionId}</td>
                    </tr>
                    <tr>
                      <td>Student Response : </td>
                      <td>{questionAnwserResponse?.studentAnswer}</td>
                    </tr>
                    <tr>
                      <td>Student Retry Response : </td>
                      <td>{questionAnwserResponse?.studentRetryResponse}</td>
                    </tr>
                  </table>
                </>
              )}

            {selectedAnswer?.crStatus?.status === 'Answered' && (
              <>
                <table>
                  <tr>
                    <td>Status : </td>
                    <td>{questionAnwserResponse?.status}</td>
                  </tr>
                  <tr>
                    <td>Sample Answer : </td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.sampleAnswer
                      }}></td>
                  </tr>
                  <tr>
                    <td>Student Answer : </td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.studentAnswer
                      }}></td>
                  </tr>
                </table>
              </>
            )}
            {selectedAnswer?.crStatus?.status === 'Not Answered' && (
              <>
                <table>
                  <tr>
                    <td>Status : </td>
                    <td>{questionAnwserResponse?.status}</td>
                  </tr>
                  <tr>
                    <td>Sample Answer : </td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.sampleAnswer
                      }}></td>
                  </tr>
                </table>
              </>
            )}
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '40px' }}>
            <HesSpinner />
            <span className="ms-3">Loading results...</span>
          </div>
        )}
      </Modal>
    </>
  )
};

export default IndividualQuestionTableVertical;